// src/components/Auth/LoginModal.js
import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { FaUser, FaLock, FaTimes } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleLogin } from "../../redux/authentication";

const LoginModal = ({ isOpen, toggle, setUserRights }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    partnerName: "",
    userId: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };
  const signUpHandler = () => {
    navigate("/store-partner-signup");
  };
  const loginHandler = async () => {
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NAADAN_API}auth`,
        {
          ...formData,
          username: formData.userId,
        },
        {
          params: { branch: formData.partnerName },
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        //   setUserRights(response.data?.rights);
        dispatch(handleLogin(response.data));
        if (response.data.branch === "John") {
          navigate("/company");
        }
        if (response.data.branch === "naadanMart") {
          navigate("/store-admin");
        }
        setSuccessMsg("✅ Login successful!");
      } else {
        setErrorMsg("❌ Invalid credentials. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("⚠️ Login failed. Please check your details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        toggle={toggle}
        close={
          <button
            type="button"
            className="naadan-close-btn"
            onClick={toggle}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        }
      >
        Partner Login
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="partnerName">Partner Name</Label>
            <Input
              type="text"
              id="partnerName"
              value={formData.partnerName}
              onChange={handleChange}
              placeholder="Enter Partner Name"
            />
          </FormGroup>
          <FormGroup>
            <Label for="userId">
              <FaUser className="me-1" /> User ID
            </Label>
            <Input
              type="text"
              id="userId"
              value={formData.userId}
              onChange={handleChange}
              placeholder="Enter User ID"
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">
              <FaLock className="me-1" /> Password
            </Label>
            <Input
              type="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter Password"
            />
          </FormGroup>
        </Form>
        {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
        {successMsg && <p className="text-success mt-2">{successMsg}</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={loginHandler} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Login"}
        </Button>
        <Button color="primary" onClick={signUpHandler} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Sign Up"}
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LoginModal;
